import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { emptyDraft, type OnboardingDraft } from './onboarding';

interface OnboardingState {
  draft: OnboardingDraft;
  /** Email awaiting its verification code (sign-up -> verify-email). Kept out of the URL. */
  pendingEmail?: string;
  updateDraft: (patch: Partial<OnboardingDraft>) => void;
  setPendingEmail: (email: string | undefined) => void;
  reset: () => void;
}

/**
 * The questionnaire runs BEFORE account creation (Figma order), so answers live in sessionStorage until
 * sign-up + email verification give us a session to POST them with. sessionStorage, not localStorage:
 * it is per-tab and gone when the tab closes.
 */
export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      draft: emptyDraft,
      pendingEmail: undefined,
      updateDraft: (patch) => set((s) => ({ draft: { ...s.draft, ...patch } })),
      setPendingEmail: (pendingEmail) => set({ pendingEmail }),
      reset: () => set({ draft: emptyDraft, pendingEmail: undefined }),
    }),
    { name: 'mbm-onboarding', storage: createJSONStorage(() => sessionStorage) },
  ),
);
